export const ROUTES = {
  INDEX: '/',
  HOME: '/home',
  PROFILE: '/profile',
  EMAIL: '/email',
  FIRM_CREATE: '/firm/create',
  FIRM: '/firm/:id',
  COMPANY_CREATE: '/company-create',
  COMPANY: '/company/:id',
  CATEGORY_LIST: '/document-library',
  CATEGORY: '/document-library/:name',
  SUBCATEGORY: '/document-library/:basic_category/:name',
  SUBCATEGORY_LEVEL_2: '/document-library/:basic_category/:name/:name',
  TEMPLATE_ITEM: `/library/:name/:id`,
  TEMPLATE_ITEMS: `/library/:name`,
  PAYMENT: '/payment',
  PAYMENT_STATUS: '/payment-status',
  SIGN_UP: '/signup',
  EMAIL_SENT: '/email-sent',
  PROCESS_SUCCESS: '/process-success',
  CONFIRMATION: '/confirmation',
  SETTINGS: '/settings',
  PASSWORD_RESET: '/password-reset',
  LOGIN: '/login',
  PRICING: '/pricing',
  PRODUCT_PLAN_CONFIRMATION: '/product-plan-confirmation',
  STRIPE_PAYMENT_LINK: 'https://pay.businesskitz.com.au/b/test_7sI15vg6egkd7XG9AB',
  STRIPE_PAYMENT_LINK_PROD: 'https://pay.businesskitz.com.au/b/00g5kUcjvfPR4jC8wx',
  SUBSCRIPTIONS: '/subscriptions',
  ACCEPTED_INVITE: '/accept_invite',
  JOIN_COMPANY: '/join_company',
  EMPLOYEE_PROFILES: '/employee-profiles',
  EMPLOYEE_PROFILE: '/employee-profiles/:employeeId',
  EMPLOYEE_PROFILE_CREATE: '/employee-profiles/create',
  EMPLOYEE_PROFILE_SETTINGS: '/employee-profile-settings',
  SUPPLIER_PROFILES: '/supplier-profiles',
  SUPPLIER_PROFILE: '/supplier-profiles/:supplierId',
  SUPPLIER_PROFILE_CREATE: '/supplier-profile/create',
  DOCUMENT_VAULT: '/document-vault',
  DOCUMENT_VAULT_CATEGORY_DOCUMENT: '/document-vault/:documentId',
  SIGNING: '/signing',
  SIGNING_DOCUMENT: '/documents/:documentId',
  DOCUMENTS: '/documents',
  CUSTOMER_PROFILES: '/customer-profiles',
  CUSTOMER_PROFILE_CREATE: '/customer-profile-v2/create',
  CUSTOMER_PROFILE: '/customer-profiles/:customerId',
  DOCUMENT_LIBRARY: '/library',
  BUSINESS_PROFILE: '/business-profile',
  DEMO_DOCUMENT_VAULT: '/demo-document-vault',
  DEMO_DOCUMENT_VIEW: '/demo-document-view',
  DEMO_DOCUMENT_WORKSPACE: '/demo-document-workspace',
  WORKSPACE: '/workspace',
  WORKSPACE_DOCUMENT: '/workspace/document/:documentId',
  DOCUMENTS_KEY_DATES: '/key-dates-documents',
  CALLBACK: '/callback',
};
